// extracted by mini-css-extract-plugin
module.exports = {"th":"queryManagement_th__1hDvN","card":"queryManagement_card__3Dmt5"};